import { useAtomValue } from 'jotai';
import {
  featureFlagsStateSegment,
  isFeatureEnabled,
} from '../store/globalStore/stateSegments/featureFlagsStateSegment';

/**
 * Hook to access feature flags state and utilities
 */
export const useFeatureFlags = () => {
  const featureFlagsState = useAtomValue(featureFlagsStateSegment);

  const checkFeature = (featureName: string): boolean => {
    return isFeatureEnabled(featureFlagsState, featureName);
  };

  return {
    ...featureFlagsState,
    checkFeature,
    // Specific feature checks for commonly used features
    isAemAssetIntegrationEnabled: checkFeature('aem-asset-integration'),
    isExtendedLibraryEnabled: checkFeature('extendedLibraryEnabled'),
    isEditTextEnabled: checkFeature('edit-text'),
    isContentRuleBookEnabled: checkFeature('content-rules'),
    isImageGenerationEnabled: checkFeature('image-generation'),
  };
};
